export default __webpack_public_path__ + "static/media/full1.0dbd3d2f.jpg";